import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import FeatureService from "../services/feature.service";
import Spinner from "./Spinner";

const errMsg = (err) =>
  (err.response && err.response.data && err.response.data.message) || err.message;

// Admin page (/feature): turn optional features on/off.
const FeatureManagement = () => {
  const { t } = useTranslation();
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyKey, setBusyKey] = useState(null);

  const load = () => {
    setLoading(true);
    FeatureService.getAll()
      .then((res) => setFeatures(res.data || []))
      .catch((err) => toast.error(errMsg(err)))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const toggle = (f) => {
    const next = !f.enabled;
    setBusyKey(f.key);
    FeatureService.setEnabled(f.key, next)
      .then((res) => {
        setFeatures((list) => list.map((x) => (x.key === f.key ? res.data : x)));
        toast.success(
          next
            ? t("features.enabledToast", { name: f.name })
            : t("features.disabledToast", { name: f.name })
        );
      })
      .catch((err) => toast.error(errMsg(err)))
      .finally(() => setBusyKey(null));
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-1">{t("features.title")}</h3>
      <p className="text-muted">{t("features.subtitle")}</p>

      {loading ? (
        <Spinner />
      ) : features.length === 0 ? (
        <p className="text-muted">{t("features.empty")}</p>
      ) : (
        <div className="row">
          {features.map((f) => (
            <div className="col-12 col-md-6 col-lg-4 mb-4" key={f.key}>
              <div className="card h-100 shadow-sm">
                <div className="card-body d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-start">
                    <h5 className="card-title mb-0">{f.name}</h5>
                    <span className={`badge ${f.enabled ? "bg-success" : "bg-secondary"}`}>
                      {f.enabled ? t("features.on") : t("features.off")}
                    </span>
                  </div>
                  <p className="card-text small text-muted mt-2 flex-grow-1">{f.description}</p>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id={`feature-${f.key}`}
                      checked={!!f.enabled}
                      disabled={busyKey === f.key}
                      onChange={() => toggle(f)}
                    />
                    <label className="form-check-label" htmlFor={`feature-${f.key}`}>
                      {f.enabled ? t("features.on") : t("features.off")}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FeatureManagement;
